
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule} from '@angular/forms'
import { RouterModule } from "@angular/router";
import { MatIconModule } from "@angular/material/icon";
import { FlexLayoutModule } from "@angular/flex-layout";
import {FuseSidebarModule} from "../../../@fuse/components";
import {TranslateModule} from "@ngx-translate/core";
import {FuseDirectivesModule} from "../../../@fuse/directives/directives";
import {MatRippleModule} from "@angular/material/core";
import {MatButtonModule} from "@angular/material/button";
import {MatMenuModule} from "@angular/material/menu";
import {NgxChartsModule} from "@swimlane/ngx-charts";
import {MatTabsModule} from "@angular/material/tabs";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {ChartsModule} from "ng2-charts";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatInputModule} from "@angular/material/input";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatDialogModule} from "@angular/material/dialog";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {DndDirective} from "../../dnd.directive";
// import {ProgressComponent} from "../cms/gallery/components/progress.component";
import {InternalFileComponent} from "./internalFile.component";
import {InternalFileResolve} from "./resolvers/internalFile.resolve";
import {FileMainSidebarComponent} from "./sidebars/main/main-sidebar.component";
import {InternalFileFormComponent} from "./internalFileForm.component";
import {GalleryModule} from "../cms/gallery/gallery.module";
import {DeleteFileDialogComponent} from "./dialog/deleteFileDialog.component";

@NgModule({
    declarations: [
        // DndDirective,
        // ProgressComponent,
        InternalFileComponent,
        FileMainSidebarComponent,
        InternalFileFormComponent,
        DeleteFileDialogComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        FlexLayoutModule,
        FuseSidebarModule,
        FuseDirectivesModule,
        MatRippleModule,
        MatButtonModule,
        MatMenuModule,
        NgxChartsModule,
        MatTabsModule,
        MatFormFieldModule,
        MatSelectModule,
        ChartsModule,
        NgxDatatableModule,
        MatDatepickerModule,
        MatInputModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatDialogModule,
        MatAutocompleteModule,
        TranslateModule,
        GalleryModule,

    ],
    providers: [
        InternalFileResolve,
    ],
    exports: [
        // DndDirective,
        // ProgressComponent
    ],
    bootstrap: [
        InternalFileComponent,
        InternalFileFormComponent,
    ]
})
export class InternalFileModule { }
